export { default as default } from './Loading';
